<template>
    <div class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full border" :class="classList">
        <template v-if="state">
            {{ $t('Yes') }}
        </template>
        <template v-else>
            {{ $t('No') }}
        </template>
    </div>
</template>

<script>

export default {
    name: "YesNoToggle",
    components: {},
    props: {
        state: Boolean,
        clickable: {
            type: Boolean,
            default: () => true,
        }
    },
    computed: {
        classList() {
            if(this.clickable)
                return (this.state ? 'border-green-100 hover:border-green-800 bg-green-100 text-green-800' : 'border-red-100 hover:border-red-800 bg-red-100 text-red-800') + ' cursor-pointer ';

            return (this.state ? 'border-green-100 bg-green-100 text-green-800' : 'border-red-100 bg-red-100 text-red-800');
        },
    },
    data() {
        return {
            form: this.$inertia.form({
                _method: 'POST',
                files: null,
            }),
        };
    },
    methods: {},
}
</script>

<style scoped>

</style>
